import { whatsappUrl } from "@/lib/share";

const money = (n) => `S$${Number(n || 0).toLocaleString("en-SG", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const dt = (s) => (s ? new Date(`${s}T00:00:00`).toLocaleDateString("en-SG", { day: "2-digit", month: "short", year: "numeric" }) : "");

// WhatsApp-formatted overdue reminder for one AR customer row (from GET /api/ar/customers)
export function overdueReminderText(row, shop) {
  const who = row.contact_person || (row.company ? row.name : "") || row.name || "Customer";
  const lines = row.overdue_invoices.map((i, n) => `${n + 1}. ${i.kind === "opening_balance" ? "Opening balance" : i.invoice_no}${i.plate ? ` (${i.plate})` : ""} — due ${dt(i.due_date)} · ${i.days_overdue}d — *${money(i.outstanding)}*`);
  const pay = [shop.paynowUen && `PayNow UEN ${shop.paynowUen}`, shop.bankDetails && shop.bankDetails.split("\n").find((l) => /bank/i.test(l))].filter(Boolean).join("\n");
  return [
    `*Payment reminder · 付款提醒*`,
    `Dear ${who},`,
    `A gentle reminder from ${shop.name}: the following ${row.overdue_invoices.length > 1 ? "invoices are" : "invoice is"} now past due:`,
    "",
    ...lines,
    "",
    `*Overdue total: ${money(row.overdue)}*` + (row.outstanding > row.overdue + 0.005 ? `  (total outstanding ${money(row.outstanding)})` : ""),
    "",
    `*Payment Method 付款方式*`,
    pay || "Please contact us for payment details.",
    "_Please quote the invoice number as reference. Kindly ignore if payment has already been made._",
    "",
    `Thank you · 谢谢!`,
    `_${shop.name}_`,
  ].join("\n");
}

export const openReminderWhatsApp = (row, shop) => window.open(whatsappUrl(row.phone, shop.countryCode, overdueReminderText(row, shop)), "_blank", "noopener");
